import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { MindMapDto } from '../dto/MindMapDto';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, getLang, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiSaveMindMapNew = async (
  route: string,
  key: string,
  type: string,
  dto: MindMapDto
) => {
  const params: IApiParams = {
    url: `/saveMindMapNew.php?baseName=${route}&keyTitle=${key}&type=${type}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
      'Api-Lang': getLang(),
    },
  };
  return getApi(params, 'POST', dto);
};
